module.exports = __webpack_public_path__ + "fonts/NeuePlakCondensedBold_normal_condensed.211061c.woff2";